var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEqualitylearning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6286 4.07152C11.867 3.97616 12.133 3.97616 12.3714 4.07152L22.3714 8.07152C22.751 8.22339 23 8.5911 23 9V15C23 15.5523 22.5523 16 22 16C21.4477 16 21 15.5523 21 15V10.477L12.3714 13.9285C12.133 14.0238 11.867 14.0238 11.6286 13.9285L1.62861 9.92848C1.24895 9.77661 1 9.4089 1 9C1 8.5911 1.24895 8.22339 1.62861 8.07152L11.6286 4.07152ZM19.3074 9L12 11.923L4.69258 9L12 6.07703L19.3074 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.6001C6.55228 9.6001 7 10.0478 7 10.6001V16.0001C7 16.2252 7.20327 16.7263 8.20457 17.227C9.15909 17.7043 10.5239 18.0001 12 18.0001C13.4761 18.0001 14.8409 17.7043 15.7954 17.227C16.7967 16.7263 17 16.2252 17 16.0001V10.6001C17 10.0478 17.4477 9.6001 18 9.6001C18.5523 9.6001 19 10.0478 19 10.6001V16.0001C19 17.3663 17.939 18.3913 16.6899 19.0158C15.3939 19.6638 13.7065 20.0001 12 20.0001C10.2935 20.0001 8.60606 19.6638 7.31015 19.0158C6.06101 18.3913 5 17.3663 5 16.0001V10.6001C5 10.0478 5.44772 9.6001 6 9.6001Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualitylearning);
export default __webpack_public_path__ + "static/media/equality.learning.3d9a952e7a142e233d9934faa6d4f632.svg";
export { ForwardRef as ReactComponent };